/* eslint-disable import/prefer-default-export */
import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";
import { ObjectTypeSysname } from "../types";

// TODO Евгений. Разобраться на какой метод заменен в числовых идентификаторах, т.к. свагере depricated
export const getDicVersionsRoute = (props: {
  objectTypeSysname: ObjectTypeSysname;
  objectId: number;
  propertyTypeAlias?: string;
}) => {
  const { objectTypeSysname, objectId, propertyTypeAlias } = props;
  return buildUrl({
    url: `${baseUrl}/dict-api/properties/${objectTypeSysname}/${objectId}/versions`,
    searchParams: { propertyType: propertyTypeAlias },
  });
};

export const getActionHistoryRoute = (objectTypeSysname: ObjectTypeSysname, objectId: number) =>
  buildUrl({ url: `${baseUrl}/dict-api/actions/${objectTypeSysname}/${objectId}` });

export const postPropertiesRoute = (objectTypeSysname: ObjectTypeSysname, objectId: number) =>
  buildUrl({ url: `${baseUrl}/dict-api/properties/${objectTypeSysname}/${objectId}` });

export const getPropertiesRoute = (props: {
  objectTypeSysname: ObjectTypeSysname;
  objectId: number;
  includeClosed?: boolean;
  onDate?: string;
}) => {
  const { objectTypeSysname, objectId, includeClosed, onDate } = props;
  return buildUrl({
    url: `${baseUrl}/dict-api/properties/${objectTypeSysname}/${objectId}`,
    searchParams: { onDate, includeClosed },
  });
};

export const patchPropertyRoute = (params: { id: number; force: boolean; fromDate: string }) => {
  const { id, fromDate, force } = params;
  return buildUrl({
    url: `${baseUrl}/dict-api/properties/${id}`,
    searchParams: { fromDate, force },
  });
};

export const getPropertiesVersionsRoute = (id: number) =>
  buildUrl({ url: `${baseUrl}/dict-api/properties/${id}/versions` });

export const deletePropertyRoute = (id: number, fromDate: string) =>
  buildUrl({
    url: `${baseUrl}/dict-api/properties/${id}`,
    searchParams: { fromDate },
  });
